import axiosPrivate from './axiosPrivate';

const requerimientosOpciones = () => {
  return axiosPrivate.get('practicantes-culminaciones/requerimientos-opciones').then((r) => r.data);
};

const listar = () => {
  return axiosPrivate.get('practicantes-culminaciones').then((r) => r.data);
};

const crear = (payload) => {
  return axiosPrivate.post('practicantes-culminaciones', payload).then((r) => r.data);
};

const actualizar = (payload) => {
  return axiosPrivate.put('practicantes-culminaciones', payload).then((r) => r.data);
};

const procesoCertificacion = (id_culminacion) => {
  return axiosPrivate.post('practicantes-culminaciones/proceso-certificacion', { id_culminacion }).then((r) => r.data);
};

const subirCertificado = (id_culminacion, archivo) => {
  const fd = new FormData();
  fd.append('id_culminacion', id_culminacion);
  fd.append('certificado', archivo);
  return axiosPrivate.post('practicantes-culminaciones/certificado', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

const planillaPagada = (id_culminacion) => {
  return axiosPrivate.post('practicantes-culminaciones/planilla-pagada', { id_culminacion }).then((r) => r.data);
};

export default {
  requerimientosOpciones,
  listar,
  crear,
  actualizar,
  procesoCertificacion,
  subirCertificado,
  planillaPagada,
};
